import React from 'react'
import { Link } from 'gatsby'
import { Builder, withChildren, BuilderBlocks } from '@builder.io/react'

export default function GatsbyLink(props) {
    const { children, to } = props
    return (
        <Link to={to}>
            <BuilderBlocks blocks={children} />
        </Link>
    )
}

Builder.registerComponent(withChildren(GatsbyLink), {
    name: 'Gatsby Link',
    inputs: [
        {
            name: 'to',
            type: 'string',
            required: true,
        }
    ]
})
